
<app-ofr-title [subDesc] = subDesc> </app-ofr-title>


<app-day-counter *ngIf= "cs.enable('headings','dayCounter')"> </app-day-counter>
